<div class="row">
    <div class="col-md-12 margin-bottom-20">
        <h2 class="mainhead ">
            <span class="text">Pricing Analysis</span>
        </h2>
        <p class="info-text">The B+E team is hard at work analyzing your property(s).</p>
    </div>
    <div class="clearfix"></div>
    <div class="price-analysis-info-wrap">
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/sale-icon.png" />
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">Sales Comparables</div>
                    <p class="info-text"> Using historical data, B+E compares the sales metrics of similar assets against your property(s).</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/market-analysis.png"/>
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">On Market Comparables</div>
                    <p class="info-text">Leveraging the largest NNN database in the industry B+E analyzes market conditions and trends to ensure pricing is accurate and competitive.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/lease-analysis.png" />
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">Lease Analysis</div>
                    <p class="info-text">B+E conducts an in-depth analysis of all lease documents in order to identify clauses that may increase or decrease the value of your property(s). </p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/market-analysis2.png" />
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">Market Analysis</div>
                    <p class="info-text">The team at B+E examines real estate trends and statistics on a national, regional, and location-specific level in order to provide an accurate valuation. Some variables considered include vacancy rates, transaction activity, economic development, and rent growth.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/site-analysis.png" />
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">Site Analysis</div>
                    <p class="info-text">B+E evaluates the underlying real estate fundamentals of your property(s) taking into account a number of factors such as traffic counts, surrounding properties, and proximity to economic drivers.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border-div d-flex price-analysis-info">
                <span class="img">
                    <img src="assets/img/credit-analysis.png" />
                </span>
                <div class="rt-info d-flex">
                    <div class="hd">Credit Analysis</div>
                    <p class="info-text">B+E reviews financial due diligence documents (if available) and/or publicly available information relating to the underlying credit of the tenant(s). A well-rounded credit summary will help establish a tenant's ability to meet rent obligations.</p>
                </div>
            </div>
        </div>
    </div>
</div>

